export default function sendToServer(url, data, completeFunction, method) {
  $.ajax({
    type: (method || "POST"),
    contentType: "application/json",
    url: url,
    data: JSON.stringify(data),
    dataType: "json",
    processData: 'false',
    complete: completeFunction
  });
}
